import { QueryObserverResult } from '@tanstack/react-query';

export interface ObjectDetailContextType<T> {
  item: T;
  status: 'loading' | 'error' | 'success';
  refetchItem: () => Promise<QueryObserverResult<T, unknown>>;
  referrer?: string;
}

export type StageEnum = (typeof StageEnum)[keyof typeof StageEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StageEnum = {
  farming: 'farming',
  processing: 'processing',
  packaging: 'packaging',
  transport: 'transport',
} as const;
